import script from "./DAS.vue?vue&type=script&setup=true&lang=ts"
export * from "./DAS.vue?vue&type=script&setup=true&lang=ts"

import "./DAS.vue?vue&type=style&index=0&id=4125e2d4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4125e2d4"]])

export default __exports__